<ng-container
  *ngIf="activityData?.api"
>
  <mng-services-woocommerce
    [config]="config"
    (onSync)="onSync($event)"
  ></mng-services-woocommerce>
</ng-container>
